import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ConfirmationEditMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsAddClicked: Function;
    setEditedData?: Function;
    setIsEdited?: Function;
};

export function ConfirmationEditMessage({
    isModalOpened,
    setIsModalOpened,
    setIsAddClicked,
    setEditedData = () => [],
    setIsEdited,
}: ConfirmationEditMessageType) {
    const { t } = useTranslation();
    function close() {
        setIsAddClicked(false);
        setIsModalOpened(!isModalOpened);
        setEditedData([]);
        if (setIsEdited !== undefined) setIsEdited!(false);
    }

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader className="text-capitalize" toggle={close}>
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-4">
                    {t("The data has not changed! Do you want to continue?")}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={close}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
